<template>
  <div>
    <div style="margin:50px 20% 100px 20%;border: 0px solid;">
      <div style="margin:30px 10px 30px 100px;text-align: left;float:left;">
        <img src="../../assets/b02.jpg" style="width: 300px;height: 300px;">
      </div>
      <div style="margin: 20px 10px 20px 10px;text-align: center;">
        <span style="font-size: 20px">【招聘西餐后厨】</span>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">联系人：</span>
          <span style="font-size: 15px;">杨</span>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">价格：</span>
          <span style="font-size: 15px;">￥3800</span>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">地区：</span>
          <Select style="width: 180px">
            <Option  label="厦门"></Option >
          </Select>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">数量：</span>
          <span style="font-size: 15px;">2位</span>
        </p>
        <p style="margin-top: 20px;">
          <Button type="warning" style="width: 200px;height: 60px;font-size: 30px;">立即咨询</Button>
          <Button type="error" style="width: 200px;height: 60px;font-size: 20px;">点击查看电话信息</Button>
        </p>
      </div>
    </div>
    <div style="margin:50px 20% 100px 20%;border: 0px solid;text-align: center">
      <span style="font-size: 20px;margin-top: 50px">信息详情</span>
      <h5><img src="../../assets/blue.png"></h5>
      <p style="margin-top: 20px">招聘西餐后厨，有需要尽早联系我。</p>
      <img src="../../assets/b02.jpg" style="margin-top: 20px">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {

      }
    },
    mounted () {

    },
    methods:{

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:link{
    color:black;
  }
  a:hover{
    color:red;
  }
  a:active{
    color:darkred;
  }
  .image-into{
    padding:10px;
  }
  .image-out{
    padding:0px;
  }
  .demo-split{
    height: 200px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 200px;
    padding: 0;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .govm-ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    /*background: url("../../assets/images/home_pic.png") no-repeat -87px -31px;*/
    position: relative;
    top: 4px;
    right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/publish/Publish02.vue